import { request } from 'utils/http/api';

export async function getConversationTokenCall() {
  return await request({
    method: 'GET',
    url: '/hubspot/conversation-token',
  });
}
